import { render, staticRenderFns } from "./AppleSignIn.vue?vue&type=template&id=164984fc"
import script from "./AppleSignIn.vue?vue&type=script&lang=js"
export * from "./AppleSignIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports